import React, { useState } from "react";
import {Login} from './Login'
export const StudentsLogin = () =>{
    return (<Login isAdmin={false} />)
}

